import {
  Typography,
  Grid,
  Button,
  Menu,
  MenuItem,
  Popover,
  CircularProgress,
  makeStyles,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  TextField,
  IconButton,
} from "@material-ui/core";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import { useEffect, useState } from "react";
import SearchEngine from "./SearchEngine";
import BooleanTable from "./BooleanTable";
import axios from "axios";
import { useHistory } from "react-router";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import {
  url,
  ConfirmInvite,
  invitationKey,
  auth_key,
  user_id,
} from "../../constants";
import { Delete } from "@material-ui/icons";

const getData = async () => {
  try {
    const response = await axios.get(`${url}Test1`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const getSearchFromImage = async (uri) => {
  try {
    const response = await axios.post(
      `${url}searchImage`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      },
      {
        Image: uri,
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const getDataSettings = async () => {
  try {
    const response = await axios.get(`${url}testSettings`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const deleteData = async (cat, ISIN, type) => {
  try {
    if (cat) {
      const response = await axios.post(
        `${url}deleteTest`,
        {
          headers: {
            "X-Api-Key": auth_key,
          },
          params: {
            User_ID: user_id,
          },
        },
        {
          Catagory: cat,
          Query: ISIN,
          Type: type,
        }
      );
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

const updateData = async () => {
  try {
    const response = await axios.get(`${url}Test2`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const addData = async (cat, ISIN) => {
  try {
    const response = await axios.post(
      `${url}addTest`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      },
      {
        Catagory: cat,
        Query: ISIN,
        Type:
          cat === "Search"
            ? "Theme"
            : cat == "DataE"
            ? "Symbol"
            : cat === "Suggestion"
            ? "Suggestion"
            : "ISIN",
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const MenuComp = (props) => {
  const setAnchorEl = props.setAnchorEl;
  const setAnchorEl1 = props.setAnchorEl1;
  const anchorEl = props.anchorEl;
  const setAddValue = props.setAddValue;

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={() => {
        setAnchorEl(null);
      }}
    >
      <MenuItem
        onClick={(e) => {
          setAddValue("Search");
          setAnchorEl1(e.currentTarget);
          setAnchorEl(null);
        }}
      >
        Query
      </MenuItem>
      <MenuItem
        onClick={(e) => {
          setAddValue("DataC");
          setAnchorEl1(e.currentTarget);
          setAnchorEl(null);
        }}
      >
        Company
      </MenuItem>
      <MenuItem
        onClick={(e) => {
          setAddValue("DataE");
          setAnchorEl1(e.currentTarget);
          setAnchorEl(null);
        }}
      >
        ETF
      </MenuItem>
      <MenuItem
        onClick={(e) => {
          setAddValue("Seggestion");
          setAnchorEl1(e.currentTarget);
          setAnchorEl(null);
        }}
      >
        Suggestion
      </MenuItem>
    </Menu>
  );
};

const Testing = () => {
  const [data, setData] = useState([]);
  const [dataSettings, setDataSettings] = useState(null);
  const [load, setLoad] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [addValue, setAddValue] = useState(null);
  const [name, setName] = useState("");
  const [search, setSearch] = useState(null);
  const history = useHistory();
  const [imageData, setImageData] = useState([]);
  const useStyles = makeStyles((theme) => ({
    popoverRoot: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  }));
  const classes = useStyles();

  useEffect(async () => {
    const confirm_ = await ConfirmInvite(invitationKey);
    if (confirm_?.Invitation != "Admin") {
      history.push("/home");
    }
  }, []);
  useEffect(async () => {
    setLoad(true);
    const data = await getData();
    setData(data);
    setLoad(false);
    const data1 = await getDataSettings();
    setDataSettings(data1);
  }, [search]);

  useEffect(() => {
    if (dataSettings) {
      var temp_data = [];
      dataSettings?.Image?.map(async (image) => {
        const response = await getSearchFromImage(image.Query);
        if (
          response.records === "No logo" ||
          response.records === "logo it not related to a company"
        ) {
          temp_data = [
            ...temp_data,
            {
              image: image.Query,
              results: "no results",
            },
          ];
        } else {
          var results = "";
          response?.map((result) => {
            results.concat(result.Name).concat(",");
          });
          temp_data = [
            ...temp_data,
            {
              image: image.Query,
              results: "no results",
            },
          ];
        }
        setImageData(temp_data);
      });
    }
  }, [dataSettings]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingTop: "10px",
        minHeight: "100vh",
      }}
    >
      <Popover
        open={cameraOpen}
        onClose={() => {
          setCameraOpen(false);
        }}
        anchorReference="none"
        classes={{
          root: classes.popoverRoot,
        }}
      >
        <Typography
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          Take picture of a logo!
        </Typography>
        <Camera
          isImageMirror={false}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          onTakePhoto={async (dataUri) => {
            await addData("Image", dataUri);
            setCameraOpen(!cameraOpen);
          }}
        />
      </Popover>
      {load ? (
        <div
          style={{
            minHeight: "50vh",
            minWidth: "50vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div>
          <Grid container justify="flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                await updateData();
                setSearch(Math.random());
              }}
            >
              Update
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                setCameraOpen(true);
              }}
              style={{ marginLeft: "5px" }}
            >
              Image
            </Button>
            <Button
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
                setIsDelete(false);
              }}
              variant="contained"
              color="primary"
              style={{ marginLeft: "5px" }}
            >
              Add new
            </Button>

            <MenuComp
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              setAnchorEl1={setAnchorEl1}
              setAddValue={setAddValue}
              isDelete={isDelete}
            />
            <Popover
              anchorEl={anchorEl1}
              open={Boolean(anchorEl1)}
              onClose={() => {
                setAnchorEl1(null);
              }}
            >
              <div style={{ minWidth: "200px", padding: "10px" }}>
                <Grid>
                  <Typography>Add</Typography>
                </Grid>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder={`Enter ${
                    addValue === "ETF" || addValue === "DataC" ? "ISIN" : "name"
                  } to add`}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  onKeyDown={async (e) => {
                    if (e.key === "Enter") {
                      await addData(addValue, name);
                      setName("");
                      setSearch(name);
                      setAnchorEl1(null);
                    }
                  }}
                />
              </div>
            </Popover>
          </Grid>
          <Grid
            container
            justify="center"
            style={{ paddingTop: "10px", paddingBottom: "10px" }}
          >
            <Typography variant="h4">Search Engine</Typography>
          </Grid>
          <Grid
            container
            justify="center"
            style={{ paddingTop: "10vh", paddingBottom: "10px" }}
          >
            <Typography variant="h4">Data ETfs</Typography>
          </Grid>
          <BooleanTable rows={data?.Data_ETFs} cat="DataE" />
          <Grid
            container
            justify="center"
            style={{ paddingTop: "10vh", paddingBottom: "10px" }}
          >
            <Typography variant="h4">Data Companies</Typography>
          </Grid>
          <BooleanTable rows={data?.Data_companies} cat={"DataC"} />
          <Grid
            container
            justify="center"
            style={{ paddingTop: "10vh", paddingBottom: "10px" }}
          >
            <Typography variant="h4">Suggestions</Typography>
            <Button
              onClick={(e) => {
                setAnchorEl2(e.currentTarget);
              }}
              size="small"
              variant="contained"
              color="primary"
              style={{ marginLeft: "5px" }}
            >
              Delete
            </Button>
            <Popover
              open={Boolean(anchorEl2)}
              anchorEl={anchorEl2}
              onClose={() => {
                setAnchorEl2(null);
              }}
            >
              <TableContainer component={Paper}>
                <Table
                  size="small"
                  style={{ tableLayout: "fixed" }}
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Suggestion</TableCell>
                      <TableCell align="right">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataSettings?.Seggestion?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )?.map((row) => (
                      <TableRow key={row?.Query}>
                        <TableCell>{row?.Query}</TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="small"
                            onClick={async (e) => {
                              await deleteData(
                                row.Catagory,
                                row.Query,
                                row.Type
                              );
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <TableRow>
                  <TableCell>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: "All", value: -1 },
                      ]}
                      colSpan={3}
                      count={dataSettings?.Seggestion.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={(event, page_) => {
                        setPage(page_);
                      }}
                      onChangeRowsPerPage={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableContainer>
            </Popover>
          </Grid>
          <SearchEngine cat="Seggestion" rows={data?.Seggestion}></SearchEngine>
          <div style={{ width: "80vw", paddingTop: "10vh" }}>
            <TableContainer component={Paper}>
              <Table size="small" style={{ tableLayout: "fixed" }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Image</TableCell>
                    <TableCell>Results</TableCell>
                    <TableCell align="right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataSettings?.Image?.map((row) => (
                    <TableRow key={row?.image}>
                      <TableCell>
                        <img src={row.Query} height={100} width={100}></img>
                      </TableCell>
                      <TableCell>
                        {
                          imageData?.find((image) => image.image === row.Query)
                            ?.results
                        }
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          size="small"
                          onClick={async (e) => {
                            await deleteData(row.Catagory, row.Query, row.Type);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {data?.SearchEngine?.map((object) => {
            return (
              <>
                <Grid
                  container
                  style={{ paddingTop: "10vh", paddingBottom: "10px" }}
                >
                  <Grid item xs={6}>
                    <Typography variant="h5">Query: {object?.Query}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      onClick={async () => {
                        const type = dataSettings?.Search.find(
                          (a) => a.Query === object?.Query
                        )?.Type;
                        await deleteData("Search", object?.Query, type);
                      }}
                      variant="contained"
                      color="primary"
                      style={{ marginLeft: "5px" }}
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
                <Grid
                  container
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >
                  <Typography variant="body1">
                    Number of Stocks: {object?.results?.values?.Number_of_Stock}
                  </Typography>
                </Grid>
                <Grid
                  container
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >
                  <Typography variant="body1">
                    Number of Etfs: {object?.results?.values?.Number_of_Etfs}
                  </Typography>
                </Grid>
                <Grid
                  container
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >
                  <Typography variant="body1">
                    Number of Bonds: {object?.results?.values?.Number_of_Bonds}
                  </Typography>
                </Grid>
                <Grid
                  container
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >
                  <Typography variant="body1">List of companies</Typography>
                </Grid>
                <SearchEngine
                  rows={object?.results?.values?.List_of_companies}
                />
                <Grid
                  container
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >
                  <Typography variant="body1">
                    List of companies sorted by Market Cap
                  </Typography>
                </Grid>
                <SearchEngine
                  rows={object?.results?.values?.List_of_companies_sorted_by_MC}
                />
              </>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Testing;
